import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stepper,
  Step,
  StepLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Alert,
  Divider,
} from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const steps = [
  "Plan Details",
   "POP Validity",
  "Scope Type",
  "Scope Selection",
 
  "Calculation Rules",
  "Eligibility",
  "Conflict Settings",
  "CP Sign-Off",
  "Review",
];

const CreatePopPlanStep2 = ({ data, setData, onNext, onBack }) => {
  return (
    <Box sx={{ p: 1 }}>
      {/* Header */}
 

      {/* Back */}
      <Typography
        variant="body2"
        sx={{ mb: 2, cursor: "pointer", color: "text.secondary" }}
        onClick={onBack}
      >
        ← Back to POPs
      </Typography>

      {/* Stepper */}
         <Stepper activeStep={2} alternativeLabel sx={{ mb: 3 }}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel
                      StepIconProps={{
                        sx: {
                          width: 36,
                          height: 36,
                          fontSize: "1rem",
                          "&.Mui-completed": { color: "#2563EB" },
                          "&.Mui-active": {
                            color: "#2563EB",
                            transform: "scale(1.15)",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiStepLabel-label": {
                          fontSize: "0.85rem",
                          mt: 1,
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>

      <Typography variant="subtitle2" color="text.secondary" mb={2}>
        Step 2 of 9: <strong>Scope Type</strong> — Project/Wing/Unit
      </Typography>

      {/* Main Card */}
      <Card variant="outlined" sx={{ borderRadius: 2 }}>
        <CardContent>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <LayersOutlinedIcon color="success" sx={{ mr: 1 }} />
            <Typography fontWeight={600}>Select Scope Type</Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" mb={3}>
            Choose how you want to apply this POP - at project, wing, or unit level.
          </Typography>

    <RadioGroup
  value={data.scopeType}
  onChange={(e) => {
    const value = e.target.value;

    setData((prev) => ({
      ...prev,
      scopeType: value,

      // 🔥 HARD RESET DEPENDENT FIELDS
      projectId: "",
      projectName: "",
      wingIds: [],
      unitIds: [],
    }));
  }}
>
          {/* Project */}
<Card
  variant="outlined"
  sx={{
    mb: 2,
    borderColor:
      data.scopeType === "project" ? "success.main" : "divider",
    backgroundColor:
      data.scopeType === "project" ? "success.lighter" : "inherit",
  }}
>
  <CardContent>
    <FormControlLabel
      value="project"
      control={<Radio />}
      label={
        <Box>
          <Typography fontWeight={500}>Project Based</Typography>
          <Typography variant="body2" color="text.secondary">
            POP applies to the entire project. Backend stores:{" "}
            <strong>Project ID</strong>
          </Typography>
        </Box>
      }
    />
  </CardContent>
</Card>

{/* Wing */}
<Card
  variant="outlined"
  sx={{
    mb: 2,
    borderColor:
      data.scopeType === "wing" ? "success.main" : "divider",
    backgroundColor:
      data.scopeType === "wing" ? "success.lighter" : "inherit",
  }}
>
  <CardContent>
    <FormControlLabel
      value="wing"
      control={<Radio />}
      label={
        <Box>
          <Typography fontWeight={500}>Wing Based</Typography>
          <Typography variant="body2" color="text.secondary">
            POP applies to selected wings. Backend stores:{" "}
            <strong>Project ID + Wing IDs</strong>
          </Typography>
        </Box>
      }
    />
  </CardContent>
</Card>

{/* Unit */}
<Card
  variant="outlined"
  sx={{
    borderColor:
      data.scopeType === "unit" ? "success.main" : "divider",
    backgroundColor:
      data.scopeType === "unit" ? "success.lighter" : "inherit",
  }}
>
  <CardContent>
    <FormControlLabel
      value="unit"
      control={<Radio />}
      label={
        <Box>
          <Typography fontWeight={500}>Unit Based</Typography>
          <Typography variant="body2" color="text.secondary">
            POP applies to specific units. Backend stores:{" "}
            <strong>Unit IDs</strong>
          </Typography>
        </Box>
      }
    />
  </CardContent>
</Card>

          </RadioGroup>

          {/* Info */}
          <Alert
            icon={false}
            sx={{
              mt: 3,
              bgcolor: "#F8FAFF",
              border: "1px solid #E3ECFF",
              fontSize: 13,
            }}
          >
            💡 The scope type determines how brokerage is calculated and which IDs
            are stored in the backend.
          </Alert>
        </CardContent>
      </Card>

      {/* Footer */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
        <Button variant="outlined" onClick={onBack}>
          ← Back
        </Button>
        <Button variant="contained" onClick={onNext}>
          Next →
        </Button>
      </Box>
    </Box>
  );
};

export default CreatePopPlanStep2;
